import { Box } from "@material-ui/core";
import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import { tesaBlue, tesaWhite } from "../../styles/colors";
import { teamsLinkUrl } from "../../styles/urls";

interface ErrorBoundaryProps {
  hasError: boolean;
  error: string;
}

interface Error {
  stack?: string;
}

export default class ErrorBoundary extends React.Component<unknown, ErrorBoundaryProps> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: "" };
  }

  static getDerivedStateFromError(error: Error): {
    hasError: boolean;
    error: string;
  } {
    // Update state so the next render will show the fallback UI.
    console.log(error);
    return { hasError: true, error: error.toString() };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // You can also log the error to an error reporting service
    console.log(errorInfo);
    this.setState({
      hasError: true,
      error: `${error} - ${errorInfo.componentStack}`,
    });
  }

  render(): React.ReactNode {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div
          style={{
            backgroundColor: tesaBlue,
            width: "100%",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <Box p={4} textAlign="center">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                margin: "auto",
                height: "100vh",
                width: "400px",
              }}
            >
              <h2>UNKNOWN ERROR</h2>
              The system encountered an unforeseen error:
              <br /> <br />
              <code style={{ maxHeight: "50vh", overflow: "scroll" }}>{error}</code>
              <br />
              For support please use MS Teams:
              <a
                style={{
                  color: tesaWhite,
                  fontFamily: "Proxima Nova Bold",
                  textDecoration: "none",
                }}
                href={teamsLinkUrl}
                rel="noopener noreferrer"
                target="_blank"
              >
                tesa_LEAP_MVP_Pilot_Phase_INT_COM
              </a>
              <br />
              To continue using LEAP click refresh:
              <br />
              <RefreshIcon
                onClick={() => document.location.reload()}
                style={{
                  cursor: "pointer",
                  marginTop: "16px",
                  fontSize: "2rem",
                }}
              />
            </div>
          </Box>
        </div>
      );
    }

    return children;
  }
}
